<template>
  <section class="pt-60 pb-60 grey-bg">
    <div class="container">
      <div class="row">
        <div class="col-xxl-12 d-flex justify-content-start">
          <div class="section__title-wrapper text-center mb-30">
            <h2 class="section__title">{{ $t('faq.title') }} <span class="yellow-bg yellow-bg-big">
                {{ $t('faq.title1') }}
                <img src="../../assets/img/shape/yellow-bg.png" alt=""></span></h2>
            <!--               <p>You don't have to struggle alone, you've got our assistance and help.</p>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div v-for="(vm, index) in faq" :key="index" class="faq-item" 
          :class="{ 'active': activeIndex == index }">
            <button class="faq-question" @click="toggleFAQ(index)">
              {{vm.question_uz}}
              <span class="icon">+</span>
            </button>
            <div class="faq-answer" :style="getAnswerStyle(index)">
              <p>{{vm.answer_uz}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '../../mixins/blogMixin';

export default {
  name: 'InstructorArea',
  mixins: [BlogMixin],
  data() {
    return {
      teamShow: false,
      activeIndex: null,
    }
  },
  computed: {
    ...mapGetters('faq', ['faq'])
  },
  created() {
    this.getFaq()
  },
  methods: {
    ...mapActions('faq', ['getFaq']),
    toggleFAQ(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    },
    getAnswerStyle(index) {
      return {};
    }
  }
};
</script>
<style scoped>
.faq-item {
    border-bottom: 1px solid #e5e5e5;
}

.faq-question {
    width: 100%;
    padding: 20px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    color: #333;
    transition: color 0.3s ease;
}

.faq-question:hover {
    color: #0056b3;
}

.icon {
    font-size: 24px;
    color: #0056b3;
    transition: transform 0.3s ease;
}

.faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    padding: 0 10px;
}

.faq-answer p {
    padding-bottom: 20px;
    color: #373737;
    line-height: 1.6;
}

/* Active holati uchun */
.faq-item.active .faq-answer {
    max-height: 200px; /* Mazmunga qarab o'zgaradi */
}

.faq-item.active .icon {
    transform: rotate(45deg); /* "+" belgisi "x" ga aylanadi */
}</style>